import type { ThemeVariant } from '@ps/web-spade-types';

import { resolveThemeVariant } from './resolveThemeVariant';

const getLoaderStyles = (theme: ThemeVariant) => `
  @keyframes loader-animation {
    0% { opacity: 1; }
    25% { opacity: 0.75; }
    50% { opacity: 0.5; }
    75% { opacity: 0.25; }
  }

  .loader-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${theme === 'dark' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)'};
    z-index: 1000;
    transition: opacity 0.3s ease-out;
    pointer-events: none;
  }

  .loader-container {
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
  }

  .loader {
    display: inline-block;
    margin: auto 2px;
    border-radius: 50%;
    background: ${theme === 'dark' ? '#ffffff' : '#000000'};
    width: 8px;
    height: 8px;
    animation: loader-animation 2s linear infinite;
  }

  .loader:nth-child(2) {
    opacity: 0.875;
    animation-delay: -1.75s;
  }

  .loader:nth-child(3) {
    opacity: 0.75;
    animation-delay: -1.5s;
  }

  .loader:nth-child(4) {
    opacity: 0.625;
    animation-delay: -1.25s;
  }
`;

export const createLoadingIndicator = (themeVariant?: ThemeVariant) => {
  const resolvedTheme = resolveThemeVariant(themeVariant);
  const styleId = `loader-styles-${resolvedTheme}`;

  if (!document.getElementById(styleId)) {
    const styleElement = document.createElement('style');
    styleElement.id = styleId;
    styleElement.textContent = getLoaderStyles(resolvedTheme);
    document.head.appendChild(styleElement);
  }

  // Create wrapper that handles positioning and backdrop
  const loaderWrapper = document.createElement('div');
  loaderWrapper.className = 'loader-wrapper';
  loaderWrapper.setAttribute('role', 'status');
  loaderWrapper.setAttribute('aria-label', 'Loading');

  const loaderContainer = document.createElement('div');
  loaderContainer.className = 'loader-container';

  for (let i = 0; i < 4; i++) {
    const loaderDot = document.createElement('span');
    loaderDot.className = 'loader';
    loaderContainer.appendChild(loaderDot);
  }

  loaderWrapper.appendChild(loaderContainer);
  return loaderWrapper;
};
